import {
  SvgWrapper,
  type SvgWrapperProps,
} from '@ipfabric/ui-components/SvgWrapper/SvgWrapper';
import { type FC, memo } from 'react';

const BareFileIcon: FC<SvgWrapperProps> = (props) => (
  <SvgWrapper viewBox='0 0 16 13' {...props}>
    <path
      d='M14 4h.13a1.5 1.5 0 011.464 1.825l-1.42 6.392a1 1 0 01-.976.783H1a1 1 0 01-1-1V1a1 1 0 011-1h3.586a1 1 0 01.707.293L7 2h5.5A1.5 1.5 0 0114 3.5V4zM6.586 3l-2-2H1v7.5l.739-3.325A1.5 1.5 0 013.203 4H13v-.5a.5.5 0 00-.5-.5H6.586zm-5.34 9h11.952l1.42-6.392A.5.5 0 0014.13 5H3.203a.5.5 0 00-.488.392L1.247 12z'
      fill='currentColor'
      className='svgicon__hover-hide'
    />
    <path
      d='M14 5h.46a1.5 1.5 0 011.431 1.948l-1.672 5.35a1 1 0 01-.954.702H1a1 1 0 01-1-1V1a1 1 0 011-1h3.586a1 1 0 01.707.293L7 2h5.5A1.5 1.5 0 0114 3.5V5zM6.586 3l-2-2H1v8.8l1.171-3.748A1.5 1.5 0 013.603 5H13V3.5a.5.5 0 00-.5-.5H6.586zM1.36 12h11.905l1.672-5.35A.5.5 0 0014.46 6H3.603a.5.5 0 00-.477.35L1.36 12z'
      fill='currentColor'
      className='svgicon__hover-show'
    />
  </SvgWrapper>
);
export const FileIcon = memo(BareFileIcon);
